import React from "react";
import LobbyModal from "./LobbyModal";
// import LobbyCTA from './LobbyCTA'
import BattleLobbyShareLink from "../battle/BattleLobbyShareLink.js";
import store from '../init/store'

class FullteamInviteModal extends React.Component {

  getText() {

    if (store.getState().matchmaking.currentRoomType === "open") {
      return "Up to six players can participate in this Rally Battle. Send or Share this Battle invite link to your friends - they will join you in this space."
    }

    return "Send this Battle link to a friend. They will join you in this space. May the best Crew win!"
  }

  render() {
    return (
      <LobbyModal
        title="Get Invite Link"
        handleCloseCallback={this.props.handleCloseCallback}
      >
        <div>
          <p className="Modal__paragraph">
            {this.getText()}
          </p>
          <p className="Modal__paragraph">Your invite link is</p>
          <BattleLobbyShareLink />
        </div>
      </LobbyModal>
    );
  }
}

export default FullteamInviteModal;



// WEBPACK FOOTER //
// ./src/b5-home/FullteamInviteModal.js